import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=24ebaaa3&scoped=true&lang=pug&"
var script = {}
import style0 from "./Box.vue?vue&type=style&index=0&id=24ebaaa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebaaa3",
  null
  
)

export default component.exports